import { Component } from '@angular/core';
import {Events, IonicPage, Loading, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiForumProvider} from "../../providers/api-forum/api-forum";
import {AppForumPostsPage} from "../app-forum-posts/app-forum-posts";
import {AppForumTopicCreatePage} from "../app-forum-topic-create/app-forum-topic-create";
import {ChatStateProvider} from "../../providers/chat-state/chat-state";

/**
 * Generated class for the AppForumTopicsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-forum-topics',
  templateUrl: 'app-forum-topics.html',
})
export class AppForumTopicsPage {

  private topicList: any[];
  private forum: any;
  forumPostPage: any = AppForumPostsPage;
  topicsCreatePage: any = AppForumTopicCreatePage;
  private unreadState: Map<string, number>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiForum: ApiForumProvider, public loaderCtrl: LoadingController, public events: Events, public chatState: ChatStateProvider) {
    this.forum = this.navParams.data.list;
  }

  newTopicCallback = null;
  ionViewDidLoad() {
    console.log('AppForumTopicsPage ionViewDidLoad', this.navParams);
    this.newTopicCallback = (event) => {
      console.log(event);
      if(event.topic.forumId == this.forum.id) {
        this.topicList.unshift(event.topic);
      }
    }
    this.events.subscribe('app:new-topic-created', this.newTopicCallback)

    this.unreadState = new Map<string, number>();
  }

  private loader: Loading;

  updateForumsState() {
    this.unreadState = new Map<string, number>();

    console.log('update state');

    this.topicList.forEach(row => {
      if(this.chatState.isTopicUnread(row.id)) {
        this.unreadState.set(row.id, 1);
      }
    })
  }


  ionViewWillLoad() {
    this.loader = this.loaderCtrl.create();
    this.loader.present();

    this.apiForum.getForumTopics(this.navParams.data.list.id).then(data => {
      this.topicList = data;
      this.loader.dismissAll();
      this.updateForumsState();

      if(this.navParams.get('redirection') && this.navParams.get('redirection').forumTopicId) {
        let topic = this.topicList.filter(t => t.id == this.navParams.get('redirection').forumTopicId);
        console.log('found topics', topic);
        if (topic.length > 0) {
          this.navCtrl.push(AppForumPostsPage, {
            forum: this.navParams.data.list,
            topic: topic[0],
          })
        }
      }
    })
    this.events.subscribe('forum:topicViewedProcessed', () => {
      this.updateForumsState();
    })

  }


}



// WEBPACK FOOTER //
// ./src/pages/app-forum-topics/app-forum-topics.ts